import React from "react";
import { Alert } from "react-bootstrap";

const DismissableAlert = ({ showAlert, dismissAlert }) => {
  if (showAlert) {
    return (
      <div className="container dismissable-alert">
        <Alert bsStyle="info" onDismiss={dismissAlert}>
          <p>To find sizes that fit your child:</p>
          <br/>
          <ol>
            <li>Set your childs height and weight with the sliders or by clicking the numbers</li>
            <li>Scroll down to see the sizes that fit</li>
            <li>Search Amazon for a size with the links provided</li>
          </ol>
        </Alert>
      </div>
    );
  }

  return null;
};

DismissableAlert.propTypes = {
  showAlert: React.PropTypes.bool.isRequired,
  dismissAlert: React.PropTypes.func.isRequired
};

export default DismissableAlert;



/** WEBPACK FOOTER **
 ** ./src/components/MainForm/DismissableAlert.js
 **/